import { ChevronLeft, FileText, Settings } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type AppHeaderVariant = 'brand' | 'title';

export interface AppHeaderProps {
  variant: AppHeaderVariant;
  title?: string;
  leftIcon?: LucideIcon;
  rightIcon?: LucideIcon;
}

export function AppHeader({
  variant,
  title,
  leftIcon,
  rightIcon,
}: AppHeaderProps) {
  const isBrand = variant === 'brand';
  const LeftIcon = leftIcon ?? (isBrand ? Settings : ChevronLeft);
  const leftIsBack = !leftIcon && !isBrand;
  const RightIcon = rightIcon ?? (isBrand ? FileText : undefined);
  const heading = title ?? (isBrand ? 'Harbor' : 'Calendar');

  return (
    <header className={`mk-header mk-header--${variant}`}>
      <span className='mk-header__side mk-header__side--left'>
        {LeftIcon ? (
          <LeftIcon
            className={`mk-header__icon${leftIsBack ? ' mk-header__back' : ''}`}
            size={leftIsBack ? 24 : 22}
            strokeWidth={leftIsBack ? 2.2 : 2}
          />
        ) : null}
      </span>
      <span className={`mk-header__title mk-header__title--${variant}`}>
        {heading}
      </span>
      <span className='mk-header__side mk-header__side--right'>
        {RightIcon ? (
          <RightIcon className='mk-header__icon' size={22} strokeWidth={2} />
        ) : null}
      </span>
    </header>
  );
}
